const zendeskEndUserBaseUrl = process.env.REACT_APP_ZENDESK_END_USER_BASE_URL;
const ariseUrl = process.env.REACT_APP_ARISE_URL;
const jarisUrl = process.env.REACT_APP_JARIS_APP_URL;

export const URLS = {
	login: "/auth",
	logout: "/logout",
	confirmEmailChange: "/confirm-email-change",
	cancelEmailChange: "/cancel-email-change",
	toTerms: "https://risewithaurora.com/terms-and-conditions",
	toPrivacy: "https://risewithaurora.com/privacy-policy",
	toPrc: "https://support.risewithaurora.com/hc/en-us/categories/40889567787155",
	toZendeskHelpCenter: `${zendeskEndUserBaseUrl}/hc`,
	ariseAffiliate: `${ariseUrl}/affiliates/view`,
	ariseMerchant: `${ariseUrl}/merchants/view`,
};

/**
 * Jaris merchant portfolio page. Needs both ids, and returns null when either
 * one or the base url is missing so callers can hide the link rather than
 * render a broken one.
 */
export const getJarisMerchantPortfolioUrl = (
	jarisMerchantId?: string,
	jarisShopId?: string,
): string | null => {
	if (!jarisUrl || !jarisMerchantId || !jarisShopId) return null;

	return (
		`${jarisUrl}/partner/merchant-portfolio/` +
		`${encodeURIComponent(jarisMerchantId)}/` +
		`${encodeURIComponent(jarisShopId)}/details`
	);
};

export const EmailUrls = {
	toHelp: "support@risewithaurora.com",
};
